import React from 'react';
import { Award, Users, BookOpen, Sparkles } from 'lucide-react';
import { aboutData } from '../data/mock';

const AboutSection = () => {
  const features = [
    {
      icon: Users,
      title: 'Trusted Convener',
      description: 'Bringing together educators, policymakers, and community leaders'
    },
    {
      icon: Award,
      title: 'Equity Champion',
      description: 'Championing policies that uplift children, families, and workforce'
    },
    {
      icon: BookOpen,
      title: 'Knowledge Leader',
      description: 'Guided by data, lived experience, and equity-centered practices'
    },
    {
      icon: Sparkles,
      title: 'System Builder',
      description: 'Strengthening the city\'s early learning system'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={aboutData.image}
                alt="Community collaboration"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent" />
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 lg:right-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs border border-slate-100">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-xl flex items-center justify-center">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="font-bold text-slate-800">10+ Years</p>
                  <p className="text-sm text-slate-500">Of Leadership</p>
                </div>
              </div>
              <p className="text-sm text-slate-600">
                Continuing the legacy of the historic Pre-K for All DC movement.
              </p>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-amber-200 rounded-full opacity-60 blur-xl" />
            <div className="absolute -bottom-8 left-1/4 w-32 h-32 bg-teal-200 rounded-full opacity-40 blur-xl" />
          </div>

          {/* Right Column - Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
              About DCELC
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6 leading-tight">
              {aboutData.title}
            </h2>

            <h3 className="text-xl text-teal-600 font-semibold mb-4">
              {aboutData.subtitle}
            </h3>

            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              {aboutData.description}
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((feature) => (
                <div
                  key={feature.title}
                  className="flex items-start gap-4 p-4 rounded-xl bg-slate-50 hover:bg-teal-50 transition-colors duration-300 group"
                >
                  <div className="w-10 h-10 bg-white rounded-lg shadow-sm flex items-center justify-center flex-shrink-0 group-hover:shadow-md transition-shadow duration-300">
                    <feature.icon className="w-5 h-5 text-teal-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-800 mb-1">
                      {feature.title}
                    </h4>
                    <p className="text-sm text-slate-500">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
